export const fetchSyllabusData = async ({ BeURL, departmentId, courseId }) => {
    try {

        const res = await fetch(
            `${BeURL}/fetch-syllabus?department=${departmentId}&course=${courseId}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const data = await res.json();
        return data;

    } catch (err) {

        console.log("Fetch syllabus error", err);

        return { success: false, message: err.message };
    }
};
